export default __webpack_public_path__ + "assets/images/placeholder_header_image.png";